"use strict";

/**
 * Обновление контейнера календарь
 */
(function(){

var self = Fotobook.containers.calendar.updater = {

    /**
     * Нужно ли обновлять вёрстку?
     * обнволяем, если сменилась дата, ориентация или первый день недели
     */
    needUpdateContent: function($old, cont){
        if (cont.calendar_date /*!= $old.attr("data-calendar_date")*/){
            return true;
        }
        if (parseInt($old.attr("data-orientation"), 10) !== cont.calendar.orientation){
            return true;
        }
        if (parseInt($old.attr("data-day_names_position"), 10) !== cont.calendar.day_names_position){
            return true;
        }

        return false;
    },

    /**
     * Обновление контейнера согласно присланным с сервера данным
     */
    updateFromResponse: function($old, cont){
        if (self.needUpdateContent($old, cont)){
            $old.find(".replace-calendar-layout").replaceWith(Fotobook.containers.calendar.drawCalendar(cont.calendar_date, cont.calendar));
        }
        $old.each(function(){
            var $this = $(this);
            $this.find(".calendar-style").replaceWith(Fotobook.containers.calendar.style.renderAll(this.id, $this.getDx(), cont.calendar));
        });
        Object.keys(cont.calendar).forEach(function(name){
            $old.attr("data-"+name, cont.calendar[name]);
        });
        $old
            .attr("data-calendar_date", cont.calendar_date)
            .find('.override-style')
            .remove()
        ;
    },
};

})();
